import { CONTACT_US_FORM, CONTACT_US_SUPPORT } from "@/constants/index"

export const addDropdownAnalytics = val => {
  const eventInfo = getEventInfo("how can we help you", false, true, val)

  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const getEventInfo = (
  value,
  needJson = true,
  interLinkTypeSameAsVal = false,
  internalLinkNameVal
) => {
  const internalLinkType = interLinkTypeSameAsVal
    ? `support:contact:${value}`
    : "support:contact:navigation"
  const internalLinkName = internalLinkNameVal ? internalLinkNameVal : value

  const eventInfo = {
    eventAction: `support:contact:form:${value}`,
    eventName: `support:contact:form:${value}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName,
    internalLinkPosition: "contact us",
    internalLinkType,
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJson) return JSON.stringify(eventInfo)
  return eventInfo
}

export const analyticsOnFindMyProduct = (
  authorData,
  interLinkTypeSameAsVal = false,
  internalLinkNameVal
) => {
  const { linkText, link } = authorData
  const eventInfo = {
    eventAction: `${CONTACT_US_SUPPORT}:${linkText.toLowerCase().trim()}`,
    eventName: `${CONTACT_US_SUPPORT}:${linkText.toLowerCase().trim()}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: internalLinkNameVal
      ? internalLinkNameVal
      : linkText.toLowerCase().trim(),
    internalLinkPosition: "contact us",
    internalLinkType: interLinkTypeSameAsVal
      ? `${CONTACT_US_FORM}:${linkText.toLowerCase().trim()}`
      : `${CONTACT_US_FORM}:navigation`,
    internalLinkZoneName: CONTACT_US_SUPPORT,
    internalLinkURL: window.origin + link,
    clickInternalLinks: "true",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo: eventInfo,
    page: page,
  })
}
